import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';

function Garantia({editarProposta, arrayGarantia, arrayGarantiaMotor, arrayGarantiaPower, garantia, setGarantia, garantiaMotor, setGarantiaMotor, garantiaPower, setGarantiaPower, setOnChangeForm}) {
    const {t} = useTranslation();
    return (
        <form className="mt-4">
            {' '}
            <div className="mb-4">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('garantia')}
                </label>
                <SelectComponent
                    isDisabled={!editarProposta}
                    options={arrayGarantia}
                    value={garantia}
                    onChange={e => {
                        setGarantia(e);
                        setOnChangeForm(true);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('selecioneOpcao')}
                    isClearable={true}
                />
            </div>
            <div className="mb-4">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('garantia2')}
                </label>
                <SelectComponent
                    isDisabled={!editarProposta}
                    options={arrayGarantiaPower}
                    value={garantiaPower}
                    onChange={e => {
                        setGarantiaPower(e);
                        setOnChangeForm(true);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('selecioneOpcao')}
                    isClearable={true}
                />
            </div>
            <div className="mb-4">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('garantia3')}
                </label>
                <SelectComponent
                    isDisabled={!editarProposta}
                    options={arrayGarantiaMotor}
                    value={garantiaMotor}
                    onChange={e => {
                        setGarantiaMotor(e);
                        setOnChangeForm(true);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('selecioneOpcao')}
                    isClearable={true}
                />
            </div>
        </form>
    );
}

export default Garantia;
